"use client";

import { useEffect, useRef, useState } from "react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

interface Props {
  value: string;
  onChange: (v: string) => void;
  /** 빨간 강조 (attempted && !value) */
  invalid?: boolean;
  placeholder?: string;
}

/** 한글 IME(조합) 안전 처리를 위한 상세주소 입력. Step2AddressInput 의 패턴을 분리·재사용. */
export default function AddressDetailInput({
  value,
  onChange,
  invalid = false,
  placeholder = "상세주소 입력 (동/호수)",
}: Props) {
  const [local, setLocal] = useState(value);
  const composingRef = useRef(false);

  useEffect(() => {
    if (!composingRef.current) setLocal(value);
  }, [value]);

  return (
    <>
      <Input
        type="text"
        placeholder={placeholder}
        value={local}
        onChange={(e) => {
          const v = e.target.value;
          setLocal(v);
          if (!composingRef.current) onChange(v);
        }}
        onCompositionStart={() => {
          composingRef.current = true;
        }}
        onCompositionEnd={(e) => {
          composingRef.current = false;
          onChange((e.target as HTMLInputElement).value);
        }}
        className={cn("w-full bg-white", invalid && "border-red-500 ring-2 ring-red-200")}
      />
      {invalid && <p className="text-sm text-red-500 mt-1">상세주소를 입력해주세요</p>}
    </>
  );
}
